import { render, staticRenderFns } from "./mensajesGrupo.vue?vue&type=template&id=14016f5e&scoped=true"
import script from "./mensajesGrupo.vue?vue&type=script&lang=js"
export * from "./mensajesGrupo.vue?vue&type=script&lang=js"
import style0 from "./mensajesGrupo.vue?vue&type=style&index=0&id=14016f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14016f5e",
  null
  
)

export default component.exports